import * as React from "react";
import { Admin, Resource, CustomRoutes, ListGuesser, fetchUtils, EditGuesser } from 'react-admin';
import { browserHistory, Router, Route } from 'react-router';
///import { UserList } from './users';
//import { PostList, PostEdit, PostCreate } from './posts';
//import jsonServerProvider from 'ra-data-json-server';
//import PostIcon from '@mui/icons-material/Book';
import { ConfigurationMainPage, ConfigMessageList, ConfigMessageEdit, ConfigMessageCreate, ConfigVariableList, ConfigVariableEdit, ConfigVariableCreate, ConfigTimetableList, ConfigTimetableEdit, ConfigDeliveryList, ConfigDeliveryEdit } from './pages/configurations';
import { UserList } from './pages/users';
import { BusinessList, BusinessEdit, BusinessCreate } from './pages/businesses';
import { ClientList, ClientEdit, ClientCreate } from './pages/clients';
import { CatalogList, CatalogEdit, CatalogCreate } from './pages/catalogs';
import { ProductList, ProductEdit, ProductCreate } from './pages/products';
import { AddressList, AddressEdit } from './pages/addresses';
import { OrderList, OrderEdit } from './pages/orders';
import { PromoList, PromoEdit, PromoCreate } from './pages/promos';
import { WebsiteContentList, WebsiteContentEdit, WebsiteContentCreate } from './pages/websiteContents';
import { AdministratorList, AdministratorEdit, AdministratorCreate } from './pages/administrators';
import { WebsiteContentCategoryList, WebsiteContentCategoryEdit } from './pages/websiteContentCategories';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import UserIcon from '@mui/icons-material/Group';
import StoreIcon from '@mui/icons-material/Store';
import BlockIcon from '@mui/icons-material/Block';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import DiscountIcon from '@mui/icons-material/LocalOffer';
import MessageIcon from '@mui/icons-material/Message';
import ProductIcon from '@mui/icons-material/AddShoppingCart';
import WebIcon from '@mui/icons-material/Web';
import MoneyIcon from '@mui/icons-material/Money';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import Dashboard from './Dashboard';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import authProvider from './providers/authProvider';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import frenchMessages from 'ra-language-french';
import simpleRestProvider from './providers/jsonDataProvider.js';
import config from "./config";
import { CustomLayout } from './layouts/layout';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { ImagesMainPage } from "./pages/images";
import CheckroomIcon from '@mui/icons-material/Checkroom';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { SubscriptionCreate, SubscriptionEdit, SubscriptionList } from "./pages/subscriptions";

const i18nProvider = polyglotI18nProvider(() => frenchMessages, 'fr');

const fetchJson = (url, options = {}) => {
  if (!options.headers) {
      options.headers = new Headers({ Accept: 'application/json' });
  }
  // add your own headers here
  options.headers.set('Authorization', 'Bearer '+localStorage.getItem("token"));
  return fetchUtils.fetchJson(url, options);
}

const dataProvider = simpleRestProvider(config.API_HOST, fetchJson);

const App = () => (
  <Admin i18nProvider={i18nProvider} layout={CustomLayout} dashboard={Dashboard} authProvider={authProvider} dataProvider={dataProvider} >
      <Resource name="users/individual" list={ClientList} edit={ClientEdit} icon={UserIcon} options={{label: "Particuliers"}} dataProvider={dataProvider} />
      <Resource name="users/business" list={BusinessList} edit={BusinessEdit} icon={StoreIcon} options={{label: "Entreprises"}} />
      <Resource name="users"/>
      <Resource name="orders" list={OrderList} edit={OrderEdit} icon={ShoppingCartIcon} options={{label: "Commandes"}} />
      <Resource name="orders/address" />
      <Resource name="address" edit={AddressEdit} />
      <Resource name="products" icon={CheckroomIcon} list={ProductList} edit={ProductEdit} create={ProductCreate} options={{label: "Produits"}} />
      <Resource name="orderProducts" />
      <Resource name="catalogProducts" />
      <Resource name="orderStatuses" />
      <Resource name="catalogs" icon={MenuBookIcon} list={CatalogList} edit={CatalogEdit} create={CatalogCreate} options={{label: "Catalogues"}} />
      <Resource name="config/message" icon={MessageIcon} list={ConfigMessageList} edit={ConfigMessageEdit} create={ConfigMessageCreate} />
      <Resource name="config/variable" icon={MessageIcon} list={ConfigVariableList} edit={ConfigVariableEdit} create={ConfigVariableCreate} />
      <Resource name="config/timetable" icon={AccessTimeIcon} list={ConfigTimetableList} edit={ConfigTimetableEdit} />
      <Resource name="config/delivery" icon={LocalShippingIcon} list={ConfigDeliveryList} edit={ConfigDeliveryEdit} />
      <Resource name="websiteContents" icon={WebIcon} list={WebsiteContentList} edit={WebsiteContentEdit} create={WebsiteContentCreate} options={{label: "Contenu"}} />
      <Resource name="websiteContentCategories" icon={BackupTableIcon} list={WebsiteContentCategoryList} edit={WebsiteContentCategoryEdit} options={{label: "Catégorie de contenu"}} />
      <Resource name="subscriptions" icon={MoneyIcon} list={SubscriptionList} edit={SubscriptionEdit} create={SubscriptionCreate} options={{label: "Fidélité"}} />
      <Resource name="administrators" icon={AdminPanelSettingsIcon} list={AdministratorList} edit={AdministratorEdit} create={AdministratorCreate} options={{label: "Administrateurs"}} />

      <CustomRoutes>
          <Route path="/configurations" element={<ConfigurationMainPage/>} options={{label: "Configuration"}} />
      </CustomRoutes>
      <CustomRoutes>
          <Route path="/images" element={<ImagesMainPage/>} options={{label: "Images"}} />
      </CustomRoutes>
  </Admin>
);
//<Resource name="posts" list={PostList} edit={PostEdit} create={PostCreate} icon={PostIcon}  />
//<Resource name="users" list={UserList} icon={UserIcon} />
// <Resource name="users" list={UserList} icon={UserIcon} />
//<Resource name="promos" icon={DiscountIcon} list={PromoList} edit={PromoEdit} create={PromoCreate} options={{label: "Promotions"}} />
export default App;


//https://marmelab.com/react-admin/FAQ.html